<template>
  <v-container fluid class="pa-8">
    <v-text-field
      v-model="search"
      label="Buscar usuário..."
      prepend-inner-icon="mdi-magnify"
      outlined
      dark
      class="search-bar mb-6 custom-input"
      @input="userList()"
      clearable
    ></v-text-field>
    <v-simple-table class="custom-table">
      <thead>
        <tr>
          <th></th>
          <th class="text-left">Nome</th>
          <th class="text-left">Nickname</th>
          <th class="text-left">Email</th>
          <th class="text-left">Level</th>
          <th class="text-left">Ação</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="user in users"
          :key="user.id"
          :class="{'selected-row': selectedUser.id === user.id}"
          style="height: 70px; font-size: 16px;"
        >
          <td>
            <v-avatar size="50" class="mr-2">
              <v-img v-if="user.profile_photo" :src="user.profile_photo"></v-img>
              <v-icon v-else large>mdi-account-circle</v-icon>
            </v-avatar>
          </td>
          <td>{{ user.name }}</td>
          <td>{{ user.nickname }}</td>
          <td>{{ user.email }}</td>
          <td>{{ user.user_level.name }}</td>
          <td>
            <v-btn icon @click="selectUser(user)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
    <div class="text-center">
          <v-pagination color="var(--zinnes-primary)" 
            v-model="paginate.current_page" 
            :length="paginate.last_page"
            total-visible="5"
            @input="userList"
            ></v-pagination>
    </div>
    <v-dialog v-model="dialog" max-width="800" dark>
      <v-card>
        <v-card-title class="headline">{{ selectedUser.name }}</v-card-title>

        <v-card-text>
          <div>Acessos</div>
          <v-row>
            <v-col cols="6">
              <v-switch
                v-model="selectedUser.commentAccess"
                label="Comentar"
                color="red"
                inset
              ></v-switch>
            </v-col>
            <v-col cols="6">
              <v-switch
                v-model="selectedUser.likeAccess"
                label="Curtir"
                color="red"
                inset
              ></v-switch>
            </v-col>
          </v-row>

          <div class="mt-4">Suspender conta</div>
          <v-row>
            <v-radio-group v-model="selectedUser.suspendDuration">
              <v-col cols="4">
                <v-radio
                  label="1 dia"
                  value="1"
                ></v-radio>
              </v-col>
              <v-col cols="4">
                <v-radio
                  label="7 dias"
                  value="7"
                ></v-radio>
              </v-col>
              <v-col cols="4">
                <v-radio
                  label="Indeterminado"
                  value="indefinite"
                ></v-radio>
              </v-col>
            </v-radio-group>
          </v-row>
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn  color="red" @click="closeDialog">Cancelar</v-btn>
          <v-btn class="zinnes-primary-btn" @click="banUser">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ModalUser ref="modal_user" :listar="userList"></ModalUser>
  </v-container>
</template>


<script>
import UserService from '@/server/UserService';
import ModalUser from '@/components/ModalUser.vue';

export default {
  name: "AdmAcessUserView",
  components:{ModalUser},
  data() {
    return {
      search: '',
      dialog: false,
      selectedUser: {},
      service: new UserService(),
      paginate: {}
    };
  },
  computed:{
    users: {
            get(){return this.$store.getters['getUsers']},
            set(dado){this.$store.dispatch('setUsers', dado)}
        }
  },
  mounted(){
    this.userList();
  },
  methods: {
    async userList(page=1){
      let params = {
        page,
        search:this.search
      } 
       let response = await this.service.list(params);
       this.users = response.data;
       this.paginate = response;
    },
    selectUser(user) {      
      this.$store.dispatch('setUser',user);
      this.$refs.modal_user.abrirModal();
    },
    closeDialog() {
      this.dialog = false;
      this.selectedUser = {};
    },
    banUser(duration) {
      alert(`Usuário ${this.selectedUser.name} banido por ${duration}`);
      this.closeDialog();
    },
  },
};
</script>

<style scoped>
.search-bar {
  max-width: 500px;
  color: white !important;
}

v-simple-table tbody tr {
  height: 70px;
}

.v-simple-table td {
  font-size: 16px;
  vertical-align: middle;
}

.v-avatar {
  margin-right: 10px;
}

.custom-table{
  background-color: #bbb6b6;
}
</style>

